import $ from "jquery";

const miClientLogo = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.mi-ClientLogo .gallery',
            slider: '.mi-ClientLogo .elementor-image-gallery'
        }
        if ($(el.main).length === 0) return

        $(el.slider).each(function () {
            const $this = $(this);
            if (!$this.hasClass('mi-ClientLogo--cloned')) {
                $this.append($this.html());
                $this.addClass('mi-ClientLogo--cloned');
            }
        })

        $(el.main).each(function () {
            const $this = $(this);
            $this.children().each(function () {
                const $child = $(this);
                console.log($child.children('img').width())
                $child.css({
                    'min-width': $child.find('img').attr('width') + 'px',
                    'height': $child.find('img').attr('height') + 'px'
                });
            })
        })
    }
    init()
}

try {
    miClientLogo()
} catch (error) {
    console.error('miClientLogo', error)
}